<div style="margin:5px">

        <kendo-grid class="invoices-stores-table"
                    #InvoicesDataTable
                    [kendoGridBinding]="stores"
                    [pageSize]="pageSize"
                    [resizable]="true"
                    [pageable]="{
                            buttonCount: buttonCount,
                            info: info,
                            type: type,
                            pageSizes: pageSizes,
                            previousNext: previousNext
                    }"
                    [sortable]="true"
                    [sort]="sort"
                    [height]="750"
                    [scrollable]="true"
                    [selectable]="{
                      mode: 'multiple',
                      checkboxOnly: false
                    }"
                    filterable="menu"
                    (pageChange)="pageChange($event)"
                    (selectionChange)="allRowsSelected($event)"
                    (selectAllChange)="allRowsSelected($event)"
                    [rowSelected]="isRowSelected"
                    [skip]="skip"
                    [kendoGridSelectBy]="selectionKey"
                    [selectedKeys]="selectedKeys"
                    [reorderable]="true"
                    [filter]="">
          <ng-template kendoGridToolbarTemplate>
            <div fxLayout="row" fxLayoutAlign="flex-start">
              <div class="master-select" (click)="masterClicked()">
                <kendo-label class="k-checkbox-label"></kendo-label>
                <input type="checkbox" #terms [(ngModel)]="masterSelect" kendoCheckBox kendoGridSelectAllCheckbox class="rounded-checkbox k-checkbox"/>
                <label class="k-checkbox-label">All Records</label>
              </div>
              <div class="master-select" (click)="bulkToggleChanged()">
                <kendo-label class="k-checkbox-label"></kendo-label>
                <input type="checkbox" #terms  [(ngModel)]="bulkSelect" kendoCheckBox class="rounded-checkbox"/>
                <label class="k-checkbox-label">Bulk Select</label>
              </div>
              <div style="margin-left: 35px">
                <span #anchor></span>
                <app-mcl-button primary="true" text="Invoice List Lookup >" (click)="onToggle()"></app-mcl-button>
                <kendo-popup *ngIf="show" [anchor]="anchor" (anchorViewportLeave)="close()">
                  <strong>
                    <app-invoice-lookup [userParentList]="parents"></app-invoice-lookup>
                  </strong>
                </kendo-popup>
              </div>
              <div>
                <kendo-grid-column-chooser class="k-column-chooser-title"></kendo-grid-column-chooser>
              </div>
            </div>
          </ng-template>

          <kendo-grid-checkbox-column [width]="90" [showSelectAll]="true" [reorderable]="false"
                                      [columnMenu]="false">
            <ng-template kendoGridHeaderTemplate>
              <input class="k-checkbox rounded-checkbox" id="selectAllCheckboxId" kendoGridSelectAllCheckbox
                     [checked]="selectAllChecked"
                     (selectAllChange)="allRowsSelected($event)">
              <label class="k-checkbox-label" for="selectAllCheckboxId">Page</label>
            </ng-template>
          </kendo-grid-checkbox-column>

          <!-- Display only Parent Customer column when bulkSelect is enabled -->
          <span *ngIf="bulkSelect; then bulkModeOn else bulkModeOff">
          </span>
          <ng-template #bulkModeOn>
            <kendo-grid-column field="billToSiteNumber" title="Parent"></kendo-grid-column>
          </ng-template>
          <ng-template #bulkModeOff>
            <kendo-grid-column field="shipToSiteNumber" title="Customer"></kendo-grid-column>
            <kendo-grid-column field="storeNumber" title="Store"></kendo-grid-column>
            <kendo-grid-column field="billToSiteNumber" title="Parent"></kendo-grid-column>
            <kendo-grid-column field="corpCode" title="Chain"></kendo-grid-column>
            <kendo-grid-column field="shipToSiteName" title="Description"></kendo-grid-column>
          </ng-template>

        </kendo-grid>

        <div class="b-button-bar">
          <app-mcl-button style="margin: 5px 5px 5px 0px;" text="< Back To Home" primary="true" (click)="backClicked()" [disabled]="false">
          </app-mcl-button>

          <app-mcl-button style="margin: 5px;" text="Next To Invoice Search >" primary="true" (click)="nextClicked()" [disabled]="!isValidSelection">
          </app-mcl-button>

          <app-mcl-button style="margin: 5px;" text="Finish" primary="true" (click)="finishClicked()" [disabled]="bulkSelect || !isValidSelection">
          </app-mcl-button>
        </div>

  <div kendoDialogContainer></div>
</div>
